// src/queries/user.ts
import { useQuery, useMutation, keepPreviousData } from "@tanstack/react-query";
import qs from "qs";
import api from "@services/api";

/* ========= LIST / DETAIL ========= */

async function fetchUsers(filters: any, page: number, pageSize: number) {
  const query = qs.stringify(
    { ...filters, page, page_size: pageSize },
    { arrayFormat: "indices", encodeValuesOnly: true }
  );
  const { data } = await api.get(`/user?${query}`);
  return data; // Laravel paginate() object
}

export function useUsersQuery(filters: any, page: number, pageSize: number) {
  return useQuery({
    queryKey: ["user", "list", filters, page, pageSize],
    queryFn: () => fetchUsers(filters, page, pageSize),
    placeholderData: keepPreviousData,
  });
}

export function useUserQuery(id?: number | string) {
  return useQuery({
    queryKey: ["user", "detail", id],
    queryFn: async () => {
      const { data } = await api.get(`/user/${id}`);
      return data;
    },
    enabled: !!id,
  });
}

/* ========= MUTATIONS ========= */

export function useCreateUserMutation() {
  return useMutation({
    mutationFn: async (payload: any) => {
      const { data } = await api.post(`/user`, payload);
      return data;
    },
  });
}

export function useSaveUserMutation() {
  return useMutation({
    mutationFn: async ({ id, payload }: { id: number | string; payload: any }) => {
      const { data } = await api.post(`/user/${id}`, payload); // or .put if you changed route
      return data;
    },
  });
}

export function useDeleteUserMutation() {
  return useMutation({
    mutationFn: async (id: number | string) => {
      const { data } = await api.delete(`/user/${id}`);
      return data;
    },
  });
}

/* ========= DROPDOWN HELPERS ========= */
/* user groups, franchises, stores for selects */

export function useUserGroupsQuery() {
  return useQuery({
    queryKey: ["user-group", "list"],
    queryFn: async () => {
      const { data } = await api.get(`/user-group`);
      return data;
    },
  });
}

export function useFranchisesSelectQuery() {
  return useQuery({
    queryKey: ["franchise", "list"],
    queryFn: async () => {
      const { data } = await api.get(`/franchise`);
      return data;
    },
  });
}

export function useStoresSelectQuery() {
  return useQuery({
    queryKey: ["store", "list"],
    queryFn: async () => {
      const { data } = await api.get(`/store`);
      return data;
    },
  });
}

